import type { GeoData } from "./geo";

export const getCookie = (name: string): string | null => {
  const cookie = ("; " + document.cookie).split("; " + name + "=");
  return cookie.length >= 2 ? cookie.pop()!.split(";").shift()! : null;
};
export const getTopLevelDomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (parts.length < 2) {
    return hostname;
  }

  return `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
};
export const setCookie = (name: string, value: string, days = 365) => {
  const expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; domain=${getTopLevelDomain()}; path=/; SameSite=Lax; expires=${expireDate.toUTCString()}`;
};
export const getGeoCookie = () => {
  const geoCookie = getCookie("Geo");
  try {
    const geo: GeoData =
      geoCookie !== null ? JSON.parse(decodeURIComponent(geoCookie)) : {};
    return geo;
  } catch {
    return {};
  }
};
